import RefreshIcon from '@mui/icons-material/Refresh';
import {
    Box,
    Card,
    CardContent,
    IconButton,
    Theme,
    Typography,
    useMediaQuery
} from '@mui/material';
import dayjs from 'dayjs';
import { useState } from 'react';
import {
    Datagrid,
    DateField,
    List,
    useListContext,
    useRecordContext,
    useTranslate
} from 'react-admin';
import { MultilineTextField } from '../../components';
import ListPagination from '../../components/ListPagination';
import { StandaloneDateRangeInput } from '../../components/StandaloneDateTimeInput';

const ListActions = () => {
    const { refetch, isFetching } = useListContext();
    const translate = useTranslate();

    return (
        <IconButton
            onClick={() => refetch()}
            disabled={isFetching}
            aria-label={translate('Atualizar')}
            size="small"
            sx={{ mr: 1 }}
        >
            <RefreshIcon />
        </IconButton>
    );
};


export const ClientLogsTab = () => {
    const record = useRecordContext();
    const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

    const [startDate, setStartDate] = useState<string>(() => {
        return dayjs().subtract(24, 'hour').toISOString();
    });
    const [endDate, setEndDate] = useState<string>(() => dayjs().toISOString());

    if (!record) return null;

    const handleFromChange = (value: string | null) => {
        if (value) setStartDate(value);
    };

    const handleToChange = (value: string | null) => {
        if (value) setEndDate(value);
    };

    const filter = {
        startDate,
        endDate,
    };

    return (
        <Card sx={{ mb: 2 }}>
            <CardContent>
                <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
                    Logs da AWS
                </Typography>

                <Box sx={{ mb: 2 }}>
                    <StandaloneDateRangeInput
                        fromValue={startDate}
                        toValue={endDate}
                        onFromChange={handleFromChange}
                        onToChange={handleToChange}
                        fromLabel="Data Inicial"
                        toLabel="Data Final"
                    />
                </Box>

                <List
                    resource={`customers/${record.id}/logs`}
                    filter={filter}
                    pagination={<ListPagination />}
                    actions={<ListActions />}
                    disableSyncWithLocation
                >
                    <Datagrid
                        bulkActionButtons={false}
                        sx={{
                            '& .RaDatagrid-rowCell': {
                                paddingTop: 1,
                                paddingBottom: 1
                            }
                        }}
                    >
                        <DateField
                            source="@timestamp"
                            label="Data"
                            showTime
                            locales="pt-BR"
                            sx={{ minWidth: isSmall ? 100 : 180 }}
                        />
                        <MultilineTextField
                            source="@message"
                            label="Mensagem"
                            sx={{ width: '100%' }}
                        />
                    </Datagrid>
                </List>
            </CardContent>
        </Card>
    );
};
